function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React, { useContext } from "react";
import cx from "classnames";
import { useUIDSeed } from "react-uid";
import { Body, CallToAction, Heading, Subheading } from "../../atoms";
import { ArrowRight } from "../../icons";
import { Section } from "../../molecules";
import { ImageContext } from "../../../context";
export var PageIntro = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "basic" : _variant, label = param.label, title = param.title, content = param.content, callToActions = param.callToActions, details = param.details, image = param.image, className = param.className, enableLines = param.enableLines, headlinevariant = param.headlinevariant;
    var seed = useUIDSeed();
    var ImageComponent = useContext(ImageContext).ImageComponent;
    var hVariant = headlinevariant || "h1";
    return /*#__PURE__*/ React.createElement(Section, {
        lines: enableLines ? "dark" : false,
        container: true,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-auto gap-7 md:gap-9"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-auto gap-5"
    }, !!label && /*#__PURE__*/ React.createElement(Subheading, null, label), !!title && /*#__PURE__*/ React.createElement(Heading, {
        variant: hVariant
    }, title)), (content || !!(callToActions === null || callToActions === void 0 ? void 0 : callToActions.length)) && /*#__PURE__*/ React.createElement("div", {
        className: cx((variant === "basic" || variant === "bigtitle") && "grid items-center gap-6 grid-cols-1 md:grid-cols-2")
    }, !!content && /*#__PURE__*/ React.createElement(Body, null, content), !!(callToActions === null || callToActions === void 0 ? void 0 : callToActions.length) && /*#__PURE__*/ React.createElement("div", {
        className: cx("flex items-center flex-wrap -m-4", (variant === "basic" || variant === "bigtitle") && "md:justify-end")
    }, callToActions.map(function(action) {
        return /*#__PURE__*/ React.createElement(CallToAction, _extends({}, action, {
            key: seed(action),
            className: "m-4",
            icon: /*#__PURE__*/ React.createElement(ArrowRight, null),
            linkVariant: "big"
        }));
    })))), (!!image || details) && /*#__PURE__*/ React.createElement("div", {
        className: "mt-7"
    }, !!details && /*#__PURE__*/ React.createElement("div", {
        className: "mb-5"
    }, details), !!image && /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _extends({
        className: "w-full"
    }, image)))));
};

//# sourceMappingURL=PageIntro.js.map